export default __webpack_public_path__ + "static/media/Icon_Chest_06_PET.3ef11330.png";